// @ts-nocheck

import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import SoftBox from "../../components/common/softBox";
import SoftTypography from "../../components/common/softTypography";
import SoftInput from "../../components/common/softInput";
import SoftButton from "../../components/common/softButton";
import { FaCirclePlus } from "react-icons/fa6";
import { getGallerySections, createGallerySection, editGallerySection } from "../../features/gallerySection"; // Replace with your actual API actions
import DashboardNavbar from "../../components/navbars/dashboardNavbar";

const ManageRoomGallery = () => {
  const dispatch = useDispatch();

  const roomGallery = useSelector((state) => state.gallerySection.gallerySections);
  const [formData, setFormData] = useState({ photo: null, is_room_gallery: false });
  const [selectedCard, setSelectedCard] = useState(null);

  useEffect(() => {
    dispatch(getGallerySections());
  }, [dispatch]);

  const handleInputChange = (e) => {
    const { name, type, checked, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "file" ? files[0] : type === "checkbox" ? checked : e.target.value,
    }));
  };
  console.log(selectedCard, 'selectedCard');

  const handleSubmit = async () => {
    const formDataPayload = new FormData();
    formDataPayload.append("photo", formData.photo);
    formDataPayload.append("is_room_gallery", formData.is_room_gallery);

    if (selectedCard) {
      // Update existing card
      dispatch(editGallerySection({ id: selectedCard._id, data: formDataPayload }))
        .then(() => toast.success("Gallery updated successfully"))
        .catch(() => toast.error("Failed to update gallery"));
    } else {
      dispatch(createGallerySection(formDataPayload))
        .then(() => toast.success("Gallery added successfully"))
        .catch(() => toast.error("Failed to add gallery"));
    }

    setFormData({ photo: null, is_room_gallery: false });
    setSelectedCard(null);
  };

  const handleEditCard = (card) => {
    setSelectedCard(card);
    setFormData({
      photo: null,
      is_room_gallery: card.is_room_gallery,
    });
  };

  return (
    <SoftBox
      className="language-box">
              <DashboardNavbar />
        
      <SoftBox >
        <SoftTypography variant="h4" fontWeight="bold" mb={3}>
          Manage Room Gallery
        </SoftTypography>

        <SoftBox display="flex" flexWrap="wrap" gap={3}>
          {roomGallery.map((card) => (
            <SoftBox key={card._id} width="200px" border="1px solid #ccc" borderRadius="8px" p={2}>
              <img
                alt="Room"
                style={{ width: "100%", height: "150px", objectFit: "cover" }}
                src={card?.photo}
              />

              <SoftTypography variant="body2" mt={2}>
                {card.is_room_gallery ? "Room Gallery" : "Not Room Gallery"}
              </SoftTypography>
              <SoftButton color="final" onClick={() => handleEditCard(card)} startIcon={<FaCirclePlus />}>
                Edit
              </SoftButton>
            </SoftBox>
          ))}
        </SoftBox>

        <SoftBox mt={2}>
          <SoftTypography variant="h6" fontWeight="medium">
            {selectedCard ? "Edit Card" : "Add New Card"}
          </SoftTypography>
          <SoftBox display="flex" flexDirection="column" gap={2} mt={0.5}>
            <SoftInput type="file" name="photo" onChange={handleInputChange} />
            <label>
              <input
                type="checkbox"
                name="is_room_gallery"
                checked={formData.is_room_gallery}
                onChange={handleInputChange}
              />
              Is Room Gallery
            </label>
            <SoftButton color="final" onClick={handleSubmit}>
              {selectedCard ? "Update" : "Add"}
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
};

export default ManageRoomGallery;
